export const validate = {
    emptystring(str) {
        let valid = true;
        if(!str) valid = false;
        return valid;
    },

    stringlen(str, minlen, maxlen) {
        let valid = true;

        if(str.length > 0) {
            if(str.length < minlen) valid = false;
            if(str.length > maxlen) valid = false;
        }
        return valid;
    },

    isnumber(num) {
        let valid = true;
        if (isNaN(num)) valid = false;
        return valid;
    },

    number(num, min, max) {
        let valid = true;

        if(num > 0) {
            if(num < min) valid = false;
            if(num > max) valid = false;
        } else {
            valid = false;
        }
        return valid;
    },

    match(str1, str2) {
        let valid = true;
        if(str1 !== str2) valid = false;
        return valid;
    },

    whitespace(str) {
        return /\s/g.test(str);
    },

    isemail(str) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(str).toLowerCase());
    },

    validateFile(filePath) {
        let valid = true;
        const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
        if(!allowedExtensions.exec(filePath)){
            valid = false;
        }

        return valid;
    },

    emptyarr(arr) {
        let valid = true;
        if(arr.length < 1) {
            valid = false;
        }

        return valid;
    },
};